/**
 * 구형 타이틀 포멧으로 변환
 * @param text
 * @returns {{icon: string, text}}
 */
export const convertTitleList = (text) => {
  return {
    icon: '',
    text: text
  }
}
